import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { AddressInputCssCarmiData, AddressInputDefinition } from '@wix/thunderbolt-components-native'

export const css = withCompInfo<AddressInputCssCarmiData, AddressInputDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compProps', 'compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compProps, compLayout, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView, compProps }
		return {
			'--fntlbl': getScaledFont(compInfo, 'fntlbl', isOneDocMigrated, compProps.labelMobileFontSize),
			'--inputFont': getScaledFont(compInfo, 'inputFont', isOneDocMigrated, compProps.inputMobileFontSize),
		}
	}
)
